/**
 * MegaRTL Image Block
 * Mandatory placeholder file.
 */

if (!customElements.get('megartl-image')) {
    class MegaRTLImage extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            // Logic for image block if needed in the future
        }
    }

    customElements.define('megartl-image', MegaRTLImage);
}
